import React from 'react';
import type { ReportStudioState } from 'src/components/star-grid/hooks/useReportStudio';
import { StudioPaletteDimension } from 'src/components/star-grid/components/StudioPaletteDimension';
import { STUDIO_DRAG_TYPE } from 'src/components/star-grid/reportStudioConstants';
import styles from 'src/components/star-grid/components/styles/ReportStudio.module.scss';
export const StudioPalette: React.FC<{ state: ReportStudioState }> = ({ state }) => (
  <aside className={styles.palette} aria-label={state.text('studioPalette')}>
    <header className={styles.panelHeader}>
      <h2>{state.text('studioDimensions')}</h2>
      <span className={styles.spacer} />
      <small className={styles.paletteCount}>{state.palette.count}</small>
    </header>
    <div className={styles.paletteBody}>
      <input
        className={styles.search}
        data-testid="studio-search"
        aria-label={state.text('studioSearchDimensions')}
        value={state.search}
        placeholder={state.palette.placeholder}
        onChange={(event) => state.setSearch(event.target.value)}
      />
      <div className={`${styles.paletteItems} ${styles.paletteScroll}`}>
        {state.palette.dimensions.map((dimension) => (
          <StudioPaletteDimension key={dimension.id} dimension={dimension} state={state} />
        ))}
      </div>
      <h3>{state.text('studioScenarios')}</h3>
      <div className={styles.paletteItems}>
        {state.scenarios.map((scenario) => (
          <article
            key={scenario.id}
            className={styles.paletteItem}
            draggable
            data-testid={`studio-scenario-${scenario.id}`}
            onDragStart={(event) => event.dataTransfer.setData(STUDIO_DRAG_TYPE, JSON.stringify({ kind: 'scenario', id: scenario.id }))}
          >
            <span className={styles.paletteName} title={scenario.label}>
              {scenario.label}
            </span>
            <div className={styles.paletteActions}>
              <button type="button" aria-label={state.text('studioAddBlock')} onClick={() => state.addScenario(scenario.id)}>
                {state.text('studioPaletteColumn')}
              </button>
            </div>
          </article>
        ))}
      </div>
    </div>
  </aside>
);
